module.exports = __webpack_public_path__ + "media/react/components/PatientBox/assets/andament_up_graph-3764f838f967e6876413d10c49bf0cc8.svg";